import React from 'react';
import Modal from 'react-modal';
import { inject, observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from '../../config';

import CopyShift from './CopyShift';
import ShiftForm from '../../forms/ShiftForm';
import '../../styles/components/Modal.css';
import '../../styles/components/ShiftModal.css';

Modal.setAppElement('#root');

export default inject('planStore', 'shiftStore')(
  observer(class ShiftModal extends React.Component {
    /**
     * Construct.
     */
    constructor(props) {
      super(props);
      this.closeModal = this.closeModal.bind(this);
      this.copyShift = this.copyShift.bind(this);
    }

    /**
     * Handle closing the modal
     * @return {void}
     */
    closeModal() {
      this.props.planStore.toggleModal(false);
    }

    /**
     * Copy shift to a new date
     *
     * @param {number} shiftId
     * @param {string} date
     * @return {void}
     */
    copyShift(shiftId, date) {
      this.props.shiftStore.copyShift(shiftId, date)
        .then(() => {
          this.props.planStore.refreshPlanningForDay(date);
        });
    }

    /**
     * Render
     * @returns {*}
     */
    render() {
      const isLoaded = typeof this.props.shiftStore.shift.shiftName !== 'undefined';

      const form = isLoaded
        ? (<ShiftForm values={this.props.shiftStore.shift} />)
        : 'Een moment geduld...';

      const copyShift = config.writeAccess && isLoaded ? (
        <CopyShift
          shiftId={this.props.shiftStore.shift.id}
          onCopy={this.copyShift}
        />
      ) : null;

      return (
        <div className=''>
          <Modal
            isOpen={this.props.planStore.shiftModalIsOpen}
            contentLabel="Ploeg modal"
            onRequestClose={() => {
              this.closeModal();
            }}
            className="shiftmodal"
          >
            <div className="modal-head">
              <div className="modal-head__title">
                Ploeg
              </div>

              <div className="modal-buttons">
                {copyShift}

                <button className="btn btn--white modal__close" onClick={this.closeModal}>
                  <FontAwesomeIcon icon="times" /> Sluit
                </button>
              </div>
            </div>

            {form}
          </Modal>
        </div>
      );
    }
  })
);



// WEBPACK FOOTER //
// ./src/components/Grid/ShiftModal.js